/// <reference path="Utilities/_reference.ts" />

//declare global {
//	var testglobal: string;

//}

module YVR.Facilities {
	// Dependencies
	import gtm = YVR.Utilities.Gtm;
	import events = YVR.Utilities.Events;
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;
	import urls = YVR.Utilities.Urls;




	let initialQuery = true;

	let options;
	// Default options
	if ($('.yvr-facility-list').hasClass('wifi')) {
		options = {
			facilities: {
				serviceUrl: '/' + i18n.getCurrentLanguage() + '/_api/Facilities',
				select: [
					'Latitude',
					'Longitude',
					'FacilityId',
					'IsOpenNow',
					'NextOpenOrClosedTime',
					'PoiAccessibility',
					'PoiAccessibilityLongDescription',
					'PoiBuildingLevel',
					'PoiCategory',
					'PoiGate',
					'PoiID',
					'PoiKeywords',
					'PoiLogo',
					'PoiNameLocID',
					'PoiSubCategory',
					'PoiTaglineLocID',
					'PoiTerminal',
					'PoiTerminalLongDescription',
					'PoiYVRLocationDesc',
					'StoreFront_4x3_Url',
					'StoreFront_4x3_2x_Url',
					'SubCategoryDescription',
					'OrderNowID',
					'ShopNow',
					'AtriusID',
					'PoiYVRNote'
				]
			},

			types: {
				serviceUrl: '/' + i18n.getCurrentLanguage() + '/_api/Facilities',
				select: [
					'PoiGate',
					'Longitude',
					'Latitude',
					'PoiCategory',
					'PoiSubCategory',
					'SubCategoryDescription'
				]
			}

		};
	} else {
		options = {
			facilities: {
				serviceUrl: '/' + i18n.getCurrentLanguage() + '/_api/Facilities',
				select: [
					'Description',
					'Description',
					'FacilityId',
					'IsOpenNow',
					'NextOpenOrClosedTime',
					'PoiAccessibility',
					'PoiAccessibilityLongDescription',
					'PoiBuildingLevel',
					'PoiCategory',
					'PoiGate',
					'PoiID',
					'PoiKeywords',
					'PoiLogo',
					'PoiNameLocID',
					'PoiSubCategory',
					'PoiTaglineLocID',
					'PoiTerminal',
					'PoiTerminalLongDescription',
					'PoiYVRLocationDesc',
					'StoreFront_4x3_Url',
					'StoreFront_4x3_2x_Url',
					'SubCategoryDescription',
					'OrderNowID',
					'ShopNow',
					'AtriusID',
					'PoiYVRNote'
				]
			},

			types: {
				serviceUrl: '/' + i18n.getCurrentLanguage() + '/_api/Facilities',
				select: [
					'PoiCategory',
					'PoiSubCategory',
					'SubCategoryDescription'
				]
			}

		};
	}

	const ANALYTICS_CATEGORY = 'facility-listing';

	// Cache
	const cache = {
		template: null
	};

	// Current facilities list
	let facilitiesCache: IFacility[] = [];

	let duplicatesCache: IFacility[] = [];

	let rebuiltFacilitiesCache: IFacility[] = [];

	let modalCache = [];

	let currentKeywordMaxLength = 1;

	// Cached elements
	const elements = {
		block: $('.yvr-facility-list'),
		buttons: $('.yvr-facility-list__tab-switcher-button'),
		keyword: $('#yvr-facility-list-search'),
		keyword_mobile: $('#yvr-facility-list-search-mobile'),
		list: $('.yvr-facility-list__list'),
		opennow: $('#yvr-form-opennow'),
		service: $('.yvr-tab-switcher__button'),
		//terminal: $('input[name="terminal-toggle"]'),
		terminal: $('#select-terminal'),
		script: $('#yvr-facility-template'),
		//security: $('input[name="security-toggle"]'),
		security: $('#select-security'),
		tabs: $('.yvr-facility-list__tab-content'),
		//type: $('.yvr-form__select')
		type: $('#select-subcategory')
	};

	const handlebardemo = {
		insert: $('.handlebar-demo'),
		script: $('#handlebars-demo')
	};


	/**
	 * Main.
	 */
	function main() {
		//console.log('main');
		if (elements.block.length) {
			eventBindings();
			initTabs();
			setupFacilityTypes();
			runFacilities();
		}

		if ($('.facility-selector').length) {
			//console.log('found facility page, setting up dropdown');
			selectFacility();
		}
		removeTabIndex();
	}


	/**
	 * Event bindings.
	 */
	function eventBindings() {
		//console.log('event binding');
		filterKeywordEventBinding();
		tabSwitcherEventBinding();
		toggleEventBinding();
		resetFiltersBinding();
	}


	/**
	 * Initialise the tabs.
	 */
	function initTabs() {
		//console.log('init tabs');
		const tab = urls.getQueryStringParameter('category');
		elements.block.find(`button[data-target="${tab}"]`).click();
	}


	/**
	 * Get the facility types
	 */
	function setupFacilityTypes() {
		//console.log('setupfacilitytypes');
		$.get(`${options.types.serviceUrl}?$select=${options.types.select.join(',')}`, data => {
			const facilities = data.value;

			if (facilities) {
				const categories: { [key: string]: any } = {};

				// Loop through all facilities
				for (const facility of facilities) {
					if (!categories[facility.PoiCategory]) {
						categories[facility.PoiCategory] = {};
					}

					// Set the text to show as the text node, the key is the value of the <option>
					if (!categories[facility.PoiCategory][facility.PoiSubCategory]) {
						categories[facility.PoiCategory][facility.PoiSubCategory] = facility.SubCategoryDescription;
					}
				}

				elements.block.find('select[data-type="STR_FOOD_DRINK"]').append(createOptionsFromObject(categories['STR_FOOD_DRINK']));
				elements.block.find('select[data-type="STR_SHOPS"]').append(createOptionsFromObject(categories['STR_SHOPS']));
				elements.block.find('select[data-type="LOC_PERSONAL_SERVICES"]').append(createOptionsFromObject(categories['LOC_PERSONAL_SERVICES']));
			}
		});
	}



	/**
	 * Create <option> elements from an object.
	 */
	function createOptionsFromObject(types: { [key: string]: { [key: string]: string } }) {
		//console.log('create options from object');
		let html = '';

		for (const type in types) {
			if (types.hasOwnProperty(type)) {
				html += `<option value="${type}">${types[type]}</option>`;
			}
		}
		////console.log('    ' + html);
		return html;
	}


	/**
	 * Run through the steps to get and render facilities.
	 */
	export function runFacilities() {
		//console.log('run facilities');
		getFacilities()
			.then(transformFacilityData)
			.then(renderFacilities)
			.then(() => {
				filterFacilityData(facilitiesCache);
			})
			.then(() => {
				$('.yvr-facility-list__image').attr('alt', '');
			})
			.then(addAdvertisementPlaceholders)
			.then(replacePlaceholder)
			.fail(() => {
				logger.error('[facilities][runFacilities] An error occured retrieving the facility data.');

				renderFacilities({ error: true });
			});

	}


	/**
	 * Get the facilities from the web service.
	 * @returns {Object} A jQuery Promise.
	 */
	export function getFacilities(): JQueryPromise<any> {

		const filter = createODataFilter();
		console.log(filter);
		// Build the OData service URL with our filters
		const url = `${options.facilities.serviceUrl}?$filter=${filter.join(' and ')}&$select=${options.facilities.select.join(',')}`;
		//console.log('url ' + url)
		////console.log('			url: ' + url);

		if (cache[url]) {
			// If the data is found in the cache

			////console.log('cached');

			const deferred = $.Deferred();

			deferred.resolve(cache[url]);

			return deferred.promise();
		} else {
			// Data is not found, get a service call
			////console.log('not cached');
			return $.ajax({
				url,
				type: 'GET',
				success(data) {
					cache[url] = data;
					console.log('[facilities][getFacilities] Successfully retrieved the facility data.');
				}
			});
		}
	}


	/**
	 * Create OData filter from form data.
	 * @returns {Array} An array of odata filters.
	 */
	function createODataFilter() {
		//console.log('		create odata filter');
		const data = getFilterFormData();

		const filter = [];
		if ($('.yvr-facility-list').hasClass('wifi')) {
			filter.push("PoiCategory eq 'STR_FOOD_DRINK' or PoiCategory eq 'STR_SHOPS' or PoiCategory eq 'LOC_PERSONAL_SERVICES or IsOpenNow eq ''true'");
		} else {
			filter.push(`PoiCategory eq '${data.service}'`);
		}

		return filter;
	}



	/**
	 * Get the facility filter values from the form.
	 * @returns {Object} All the filter data.
	 */
	function getFilterFormData() {
		return {
			service: elements.service.filter('.yvr-tab-switcher__button--active').data('category'),
			category: elements.service.filter('.yvr-tab-switcher__button--active').data('target'),
			//terminal: elements.terminal.filter(':checked').val(),
			terminal: elements.terminal.val(),
			//security: elements.security.filter(':checked').val(),
			security: elements.security.val(),
			type: elements.type.val(),
			opennow: elements.opennow.is(':checked')
		};
	}


	/**
	 * Transforms the facility data and removes unnecessary OData metadata.
	 * @param {Object} data The facility data from the OData web service.
	 * @returns {Object}    The trasnformed facility data.
	 */
	function transformFacilityData(data) {
		//console.log('transform fac data');
		//console.log(data);
		const list = data.value;

		list.sort((a, b) => a.PoiNameLocID.localeCompare(b.PoiNameLocID));

		//find duplicates code here

		facilitiesCache = list;

		let combinedList = findDuplicates(list);

		//console.log(list);

		return {
			data: combinedList
		};
	}

	function findDuplicates(data) {
		//console.log('find duplicates');

		let duplicates = [];

		let rebuilt = [];

		//duplicates.push(testItem);
		////console.log(data);
		for (let i = 0; i < data.length; i++) {
			////console.log(data[i]);

			let item = data[i];
			////console.log(item.PoiNameLocID);

			let list = $.grep(data, function (node) {
				return node.FacilityId === item.FacilityId;
			});

			////console.log(list);

			if (list.length > 1) {

				//create modal cache



				let modalList = [];
				for (let j = 0; j < list.length; j++) {
					let listItem = list[j];
					if (!listItem.IsOpenNow) {
						listItem['ModalDisabled'] = 'disabled';
					}
					if (listItem.OrderNowID) {
						modalList.push(listItem);
					}
				}

				if (modalList.length > 0) {
					if (!modalCache.find(mod => mod.FacilityId == modalList[0].FacilityId)) {
						modalList['FacilityId'] = modalList[0].FacilityId;
						modalCache.push(modalList);
					}
				}


				//create duplicates list
				let PoiIDs = [];
				for (const obj of list) {

					if (!duplicates.find(dup => dup.PoiID == obj.PoiID)) {
						////console.log('pushing to duplicates list');
						//obj['ANewRefreshingField'] = 'foo' + obj.PoiID;
						duplicates.push(obj);

					}

					PoiIDs.push(obj.PoiID);

				}

				let AtriusIDs = [];
				for (const obj of list) {

					if (!duplicates.find(dup => dup.AtriusID == obj.AtriusID)) {
						////console.log('pushing to duplicates list');
						//obj['ANewRefreshingField'] = 'foo' + obj.PoiID;
						duplicates.push(obj);

					}

					AtriusIDs.push(obj.AtriusID);

				}

				//combining item
				if (!rebuilt.find(reb => reb.FacilityId == item.FacilityId)) {

					////console.log('pushing to rebuilt list');

					let rebuiltItem = list.find(li => li.IsOpenNow == true);

					let orderNowItem = list.find(op => op.OrderNowID);

					let atriusItem = list.find(li => li.AtriusID);

					if (rebuiltItem == null) {
						////console.log('its nuill');
						rebuiltItem = list[0];
					}
					////console.log(PoiIDs);
					rebuiltItem['MultiLocation'] = true;
					rebuiltItem['PoiIDs'] = PoiIDs.toString();
					rebuiltItem['AtriusIDs'] = AtriusIDs.toString();
					if (orderNowItem) {
						rebuiltItem['OrderNowID'] = orderNowItem.OrderNowID;
					}
					// if (atriusItem) {
					// 	rebuiltItem['AtriusID'] = atriusItem.AtriusID;
					// }
					////console.log(rebuiltItem);

					rebuilt.push(rebuiltItem);
				}


			} else {
				//item['MultiLocation'] = false;
				//item['PoiIDs'] = "";
				rebuilt.push(item);
			}
		}
		////console.log('duplicates');
		////console.log(duplicates);

		duplicatesCache = duplicates;



		rebuiltFacilitiesCache = rebuilt;

		console.log('rebuilt');
		console.log(rebuiltFacilitiesCache);



		return rebuilt;
	}


	/**
	 * Filters the facility data list by hiding and showing elements.
	 */
	function filterFacilityData(list: IFacility[]) {
		//console.log('filter facility data');
		let data = getFilterFormData();
		////console.log(data);
		let keyword = elements.keyword.val().removeDiacritics().toLocaleLowerCase();
		////console.log(keyword);
		// Update the current facilities list by removing elements that do not need to be shown.
		if (keyword) {
			list = $.grep(list, function (node) {
				return (node.PoiNameLocID && node.PoiNameLocID.removeDiacritics().toLocaleLowerCase().includes(keyword)) ||
					(node.Description && node.Description.removeDiacritics().toLocaleLowerCase().includes(keyword)) ||
					(node.PoiTaglineLocID && node.PoiTaglineLocID.removeDiacritics().toLocaleLowerCase().includes(keyword)) ||
					(node.PoiKeywords && node.PoiKeywords.removeDiacritics().toLocaleLowerCase().includes(keyword));
			});
		}

		if (initialQuery) {
			data = getArgumentsFromUrl(data);
		}

		////console.log(data);
		////console.log(facilitiesCache);

		updateUrl(data);
		if (data.terminal !== 'All') {
			list = $.grep(list, function (node) { return node.PoiTerminal.toLowerCase().includes(data.terminal.toLowerCase()); });
			////console.log('teminal not all');
			////console.log(list);
		}

		if (data.security !== 'All') {
			list = $.grep(list, function (node) { return node.PoiAccessibility === data.security; });
			////console.log('security not all');
			////console.log(list);
		}

		if ($('#yvr-facility-list-search').hasClass('wifi') == true) {

		} else {
			if (data.type !== 'All') {
				////console.log(data.type);
				list = $.grep(list, function (node) { return node.PoiSubCategory === data.type; });
				////console.log('data not all');
				////console.log(list);
			}
		}

		if (data.opennow) {
			list = $.grep(list, function (node) { return node.IsOpenNow === data.opennow; });
		}
		//console.log(list);
		// Convert the list of elements to an array of IDs for easier usage.
		let listIds = jQuery.map(list, function (element, index) { return element.PoiID; });
		//console.log(listIds);
		//console.log('Result count: ' + listIds.length);
		// Loop through each facility and match the IDs to the global list.
		let curGate = getCookies('GATE');
		if (curGate != '' && $('#yvr-facility-list-search').hasClass('wifi') == true) {
			elements.block.find('.yvr-facility-list__item').each(function (index, element) {
				let facility = $(element);
				let dataId = element.getAttribute('data-id');
				let dataGate = element.getAttribute('data-gate');
				////console.log('datagate = ' + dataGate);
				let id = parseInt(dataId, 10);
				////console.log('dataGate == ' + dataGate + ' curGate == '+curGate);

				if (dataGate == ' ' || dataGate == null || dataGate == '') {
					facility.hide();
				} else if (!listIds.includes(id)) {
					facility.hide();
				} else if (curGate.charAt(0) != dataGate.charAt(0)) {
					////console.log(dataGate.charAt(0));
					facility.hide();
				} else if (dataGate.charAt(0) == curGate.charAt(0)) {
					facility.show();
				}
			});
		} else {
			////console.log('else');
			elements.block.find('.yvr-facility-list__item').each(function (index, element) {
				let facility = $(element);
				////console.log(facility);
				let dataId = element.getAttribute('data-id');
				////console.log(dataId);
				let id = parseInt(dataId, 10);
				////console.log(id);

				let dataIds = element.getAttribute('data-ids');
				////console.log(dataIds);

				if (dataIds.length > 0) {
					////console.log('this is a multi location');
					let dataIdsSplit = dataIds.split(',');

					let show = false;

					let i = 0;
					while (show === false && i < dataIdsSplit.length) {
						let tempId = dataIdsSplit[i];
						let tempIdInt = parseInt(tempId, 10);
						////console.log(tempId);
						if (listIds.includes(tempIdInt)) {
							////console.log('big list contains one or more shows');
							show = true;
						}
						i++;
					}

					if (listIds.length != 0) {
						if (show) {
							////console.log('show');
							facility.show();
						} else {
							////console.log('hide');
							facility.hide();
						}
					} else {
						////console.log('straight up hiding');
						elements.block.find('.yvr-facility-list__item').hide();
					}
				} else {
					////console.log('this is a single location');
					if (listIds.length != 0) {
						////console.log('list length not 0');
						if (!listIds.includes(id)) {
							////console.log('hide');
							facility.hide();
						} else {
							////console.log('show');
							facility.show();
						}
					} else {
						////console.log('straight up hiding');
						elements.block.find('.yvr-facility-list__item').hide();
					}
				}
			});
		}
	}


	/**
	 * Render the facility listing.
	 * @param {Object} data The facility data from the OData web service.
	 */
	function renderFacilities(data) {
		//console.log('render Facilities');
		if (!cache.template) {
			//if (elements.script.length) {
			//	////console.log(elements.script.html());
			//	cache.template = Handlebars.compile(elements.script.html());
			//}

			if (document.documentElement.lang === "fr") {
				cache.template = YVR.templates.facilityFR;
			} else {
				cache.template = YVR.templates.facilityEN;
			}

			//console.log(cache.template);
		}

		//console.log(data);
		//console.log(data.data);

		//facilitiesCache = data.data;



		const html = cache.template(data);

		elements.list.html(html);

		//console.log('duplicate data');
		//console.log(duplicatesCache);

		//render modal
		//console.log('modal data');
		//console.log(modalCache);

		let template = $('#yvr-modal-template').html();
		//Compile the template data into a function
		//let templateScript = Handlebars.compile(template);


		let templateScript = YVR.templates.modal;

		let modalData = prepareForRender(modalCache);

		let context = modalData;
		let htmlModal = templateScript(context);



		$('.modal-list').html(htmlModal);

		eventModalBinding();

	}

	function prepareForRender(data) {
		console.log(data);
		return {
			beta: data
		};
	}

	function eventModalBinding() {

		for (let i = 0; i < modalCache.length; i++) {

			let item = modalCache[i];

			let id = '#btnFormSubmit' + item.FacilityId;

			$(id).on('click', function submitForm(event) {
				event.preventDefault();
				event.stopPropagation();

				let href = '',
					inputs = this.parentNode.getElementsByTagName('input');
				for (let i = 0; i < inputs.length; i++) {
					if (inputs[i].getAttribute('name') == 'button' && inputs[i].checked) {
						href = inputs[i].getAttribute('data-href-ordernow');
						window.location = href;
					}
				}
			}
			);
		}


	}


	/**
	 * Filter through the facility list with the current keyword.
	 */
	function filterKeywordEventBinding() {
		//console.log('filter keyword event binding');

		// Get the new query from the input
		if ($('#yvr-facility-list-search').hasClass('wifi') == false) {
			elements.block.on('input keyup paste', '#yvr-facility-list-search', events.throttle(function (e) {
				$('#yvr-facility-list-search-mobile').val($(e.target).val());

				filterFacilityData(facilitiesCache);
				let value = $(e.target).val().trim();
				if (value && value.length > currentKeywordMaxLength) {
					gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|keyword', value);
					currentKeywordMaxLength = value.length;
				}
			}, 200));
			elements.block.on('click', '.yvr-form__input-button', function (e) {
				e.preventDefault();
				filterFacilityData(facilitiesCache);
			});
		} else {
			elements.block.on('input keyup paste', '#yvr-facility-list-search', events.throttle(function (e) {
				$('#yvr-facility-list-search-mobile').val($(e.target).val());

				filterFacilityData(facilitiesCache);
				let value = $(e.target).val().trim();
				if (value && value.length > currentKeywordMaxLength) {
					gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|keyword', value);
					currentKeywordMaxLength = value.length;
				}
			}, 200));
			elements.block.on('click', '.yvr-form__input-button', function (e) {
				e.preventDefault();
				filterFacilityData(facilitiesCache);
			});
		}

		elements.block.on('input keyup paste', '#yvr-facility-list-search-mobile', events.throttle(function (e) {

			$('#yvr-facility-list-search').val($(e.target).val());

			filterFacilityData(facilitiesCache);
			let value = $(e.target).val().trim();
			if (value && value.length > currentKeywordMaxLength) {
				gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|keyword', value);
				currentKeywordMaxLength = value.length;
			}
		}, 200));
		elements.block.on('click', '.yvr-form__input-button', function (e) {
			e.preventDefault();
			filterFacilityData(facilitiesCache);
		});
	}

	/**
	 * Get's cookies
	 */
	function getCookies(cname) {
		//console.log('get cookies');
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}


	/**
	 * Switch various content when a tab button is pressed.
	 */
	function tabSwitcherEventBinding() {
		//console.log('tab switcher event binding');
		const activeClass = 'yvr-tab-switcher__button--active';

		elements.block.on('click', '.yvr-facility-list__tab-switcher-button', function (e) {
			e.preventDefault();

			const $this = $(this);
			const target = $this.data('target');
			const tab = elements.tabs.filter(`[data-tab-content="${target}"]`);

			if (tab.length) {
				elements.buttons.removeClass(activeClass);
				elements.buttons.attr('aria-selected', 'false');
				$this.addClass(activeClass);
				$this.attr('aria-selected', 'true');
				elements.tabs.hide();
				tab.show();
				//console.log('Tab switch: ' + $this.text().trim());
				runFacilities();

				gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|category', $this.text().trim());
			}
		});
	}


	/**
	 * Re-run the get and render functions when terminal or security inputs change.
	 */
	function toggleEventBinding() {
		//console.log('toggle event binding');

		let subcategorySelect = $('#select-subcategory-mobile, #select-subcategory');

		subcategorySelect.change(function (e) {
			subcategorySelect.val(this.value);
			filterFacilityData(facilitiesCache);
		});

		let terminalSelect = $('#select-terminal-mobile, #select-terminal');

		terminalSelect.change(function (e) {
			terminalSelect.val(this.value);
			filterFacilityData(facilitiesCache);
		});

		let securitySelect = $('#select-security-mobile, #select-security');

		securitySelect.change(function (e) {
			securitySelect.val(this.value);
			filterFacilityData(facilitiesCache);
		});

		//elements.block.on('change', '#select-subcategory, #select-terminal, #select-security, #select-subcategory-mobile, #select-terminal-mobile, #select-security-mobile', e => {
		//	filterFacilityData(facilitiesCache);
		//});

		elements.block.on('change', '.yvr-form__select, #select-subcategory, #select-terminal, #select-security, #select-subcategory-mobile, #select-terminal-mobile, #select-security-mobile', e => {
			//console.log('GTM');
			//console.log($(e.target).find('option:selected').text().trim());
			gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|sub-category', $(e.target).find('option:selected').text().trim());

		});

		elements.block.on('change', '.yvr-form__toggle[name="terminal-toggle"]', e => {
			//console.log('GTM');
			//console.log($(e.target).val().trim());
			gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|terminal', $(e.target).val().trim());
			let selector = 'label[for=' + $(e.target).attr('id') + ']';
			let label = $(selector);
		});

		elements.block.on('change', '.yvr-form__toggle[name="security-toggle"]', e => {
			//console.log('GTM');
			//console.log($(e.target).val().trim())
			gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|accessibility', $(e.target).val().trim());
			let selector = 'label[for=' + $(e.target).attr('id') + ']';
			let label = $(selector);
		});

		elements.block.on('change', '.yvr-form__checkbox', e => {
			const label = $(e.target).is(':checked') ? 'open now' : 'all';

			gtm.eventToDataLayer(ANALYTICS_CATEGORY, 'filter|open-now', label);
		});
	}

	/**
	 * Checks for query string in the url and changes filters
	 */
	function getArgumentsFromUrl(data) {
		//console.log('get arguments from url');

		//console.log(data);

		let queryString = window.location.search;

		let urlParams = new URLSearchParams(queryString);

		// All, Domestic, US, International, South Terminal
		let terminal = urlParams.get('terminal');

		if (terminal !== null) {
			if (terminal.toLowerCase() === 'all') {
				data.terminal = 'All';
				//document.getElementById("terminal-toggle-all").checked = true;
				$('#select-terminal, #select-terminal-mobile').val('All');
			} else if (terminal.toLowerCase() === 'domestic' || terminal.toLowerCase() === 'canada') {
				data.terminal = 'Domestic';
				//document.getElementById("terminal-toggle-domestic").checked = true;
				$('#select-terminal, #select-terminal-mobile').val('Domestic');
			} else if (terminal.toLowerCase() === 'us') {
				data.terminal = 'US';
				//document.getElementById("terminal-toggle-usa").checked = true;
				$('#select-terminal, #select-terminal-mobile').val('US');
			} else if (terminal.toLowerCase() === 'international') {
				data.terminal = 'International';
				//document.getElementById("terminal-toggle-international").checked = true;
				$('#select-terminal, #select-terminal-mobile').val('International');
			} else if (terminal.toLowerCase() === 'south+terminal' || terminal.toLowerCase() === 'southterminal' || terminal.toLowerCase() === 'south') {
				data.terminal = 'South';
				//document.getElementById("terminal-toggle-south").checked = true;
				$('#select-terminal, #select-terminal-mobile').val('South');
			}
		}

		// All, Before, After
		let security = urlParams.get('security');

		if (security !== null) {
			if (security.toLowerCase() === 'all') {
				data.security = 'All';
				//document.getElementById("security-toggle-dine").checked = true;
				$('#select-security, #select-security-mobile').val('All');
			} else if (security.toLowerCase() === 'before') {
				data.security = 'Before';
				//document.getElementById("security-toggle-shop").checked = true;
				$('#select-security, #select-security-mobile').val('Before');
			} else if (security.toLowerCase() === 'after') {
				data.security = 'After';
				//document.getElementById("security-toggle-services").checked = true;
				$('#select-security, #select-security-mobile').val('After');
			}
		}

		// false, true
		//var open = urlParams.get('open');

		//if (open !== null) {
		//	if (open.toLowerCase() === 'false') {
		//		data.opennow = false;
		//	}
		//	else if (open.toLowerCase() === 'true') {
		//		data.opennow = true;
		//		document.getElementById("yvr-form-opennow").checked = true;
		//	}
		//}

		// category shop dine services
		let category = urlParams.get('category');

		if (category !== null) {
			data.category = category.toLowerCase();

			if (category.toLowerCase() === 'dine') {
				data.services = 'STR_FOOD_DRINK';
				elements.tabs.filter(`[data-tab-content="dine"]`);

			} else if (category.toLowerCase() === 'shop') {
				data.services = 'STR_SHOPS';
				elements.tabs.filter(`[data-tab-content="shop"]`);


			} else if (category.toLowerCase() === 'services') {
				data.services = 'LOC_PERSONAL_SERVICES';
				elements.tabs.filter(`[data-tab-content="services"]`);
			}
		}

		if (initialQuery) {
			initialQuery = false;
		}

		return data;
	}

	 /**
	 * Updates url with new querystring based on selected tabs
	 */
	function updateUrl(data) {
		//console.log('update url');
		let url = window.location.href.split('?')[0];
		const params = new URLSearchParams({
			terminal: data.terminal,
			security: data.security,
			//open: data.opennow,
			category: data.category
		});

		let newUrl = url + '?' + params.toString();

		history.replaceState({}, null, newUrl);
	}

	function removeTabIndex() {
		//console.log('remove tab index');
		$('.yvr-facility__map').bind('DOMSubtreeModified', function (e) {
			if ($(e.target).hasClass('leaflet-container')) {
				$('.leaflet-marker-icon').attr('tabindex', '-1');
				updateAria();
			}

		});
		return this;
	}

	function updateAria() {
		//console.log('update aria');
		let h1 = $('.yvr-heading__h1').text();

		$('.yvr-facility__location').each(function (i, e) {
			let terminal = $($(e).find('.yvr-facility__location-detail')[0]).text().trim().replace(/\s+/g, ' ');
			let link = $(e).find('.leaflet-popup-content a');
			let ariaDescribed = link.attr('aria-label');
			if (link.length > 0) {
				link.attr('aria-label', h1 + ' location in ' + terminal);
				link.attr('aria-haspopup', 'true');

			}
		});
	}

	function handlebarTest() {
		//let source = $('#entry-template').html();

		////console.log('test handlebar');
		let template = $('#handlebars-demo').html();

		let context = { 'name': 'Ritesh Kumar', 'occupation': 'developer' };

		//Compile the template data into a function
		//let templateScript = Handlebars.compile(handlebardemo.script.html());

		let html = templateScript(context);
		//html = 'My name is Ritesh Kumar . I am a developer.'

		handlebardemo.insert.html(html);
		////console.log('render Facilities');
		//if (!cache.template) {
		//	if (elements.script.length) {
		//		//console.log(elements.script.html());
		//		cache.template = Handlebars.compile(elements.script.html());
		//	}
		//}

		//facilitiesCache = data.data;

		//const html = cache.template(data);

		//elements.list.html(html);
	}

	function selectFacility() {

		//console.log('select facility');

		$('#select').change(function () {

			let optionValue = $(this).val();

			$('.facility-info').hide();

			if (optionValue) {
				$('.facility-info[data-facility="' + optionValue + '"]').show();
			}

		}).change();
	}

	function resetFiltersBinding() {
		//console.log('reset filters binding');

		$('#reset-filters-mobile').add('#reset-filters').click(function () {
			//console.log('reset filter mobile button clicked');

			$('#select-terminal option:selected').prop('selected', false);
			$('#select-terminal option:first').prop('selected', 'selected');
			$('#select-terminal-mobile option:selected').prop('selected', false);
			$('#select-terminal-mobile option:first').prop('selected', 'selected');

			$('#select-security option:selected').prop('selected', false);
			$('#select-security option:first').prop('selected', 'selected');
			$('#select-security-mobile option:selected').prop('selected', false);
			$('#select-security-mobile option:first').prop('selected', 'selected');

			$('#select-subcategory option:selected').prop('selected', false);
			$('#select-subcategory option:first').prop('selected', 'selected');
			$('#select-subcategory-mobile option:selected').prop('selected', false);
			$('#select-subcategory-mobile option:first').prop('selected', 'selected');

			elements.keyword.val('');
			elements.keyword_mobile.val('');

			filterFacilityData(facilitiesCache);
		});
	}

	function addAdvertisementPlaceholders() {
		$('.yvr-facility-list__item').slice(0, 3).each(function (index) {
			$(this).before(
				'<div style="display:none;" class="yvr-facility-list__item item-col" id="placeholder-' + (index + 1) + '"></div>'
			);
		});
	}

	function replacePlaceholder() {
		let advertisement = $('#dine-shop-service-advertisement');

		if (!advertisement.length) {
			$('[id^="placeholder-"]').remove();
			return;
		}


		let position = advertisement.data('position');

		$('#placeholder-' + position).replaceWith(advertisement);

		// Remove all remaining placeholders
		$('[id^="placeholder-"]').remove();
	}


	main();
	//handlebarTest();

}
